import React, { FC, memo } from "react";
import { createUseStyles } from "react-jss";

import SceneContainer from "Containers/Scene";
import { areEqualShallow } from "Utils/areEqual";
import DirectionsAndPopUps from "Containers/DirectionsAndPopUps";
import styles from "./styles";

interface Props {
  currentStop: number;
  mapObj: any;
  locId: any;
}

const Map: FC<Props> = memo(({ currentStop, mapObj, locId }: Props) => {
  const useStyles = createUseStyles(styles);
  const classes = useStyles();
  return (
    <div
      className={classes.mapContainer}
      id="campusMap"
      data-testid="campusmap"
    >
      <DirectionsAndPopUps mapObj={mapObj} />
      {currentStop !== -1 && (
        <SceneContainer
          currentStop={currentStop}
          locId={locId}
          mapObj={mapObj}
        />
      )}
    </div>
  );
}, areEqualShallow);
export default Map;
